/* eslint react/forbid-prop-types:0 */

import React from "react";
import PropTypes from "prop-types";
import SearchResult from "./SearchResult";
import { sortPlatforms } from "../../util/tools";

const SearchResults = ({
  SearchQuery,
  Title,
  Results,
  handlePlatformSelect
}) => {
  const SortedRoutes = Results.sort((result1, result2) =>
    sortPlatforms(result1.attributes, result2.attributes)
  );

  return (
    <div className="next-bus__list">
      {Results.length ? (
        <div>
          <div>{Title}</div>
          <ul className="list">
            {SortedRoutes.map(feature => (
              <SearchResult
                key={feature.attributes.PlatformTag}
                handlePlatformSelect={handlePlatformSelect}
                PlatformName={feature.attributes.PlatformName}
                Bearing={feature.attributes.BearingToRoad}
                PlatformNo={feature.attributes.PlatformNo}
                PlatformTag={feature.attributes.PlatformTag}
                RouteNos={feature.attributes.RouteNos}
              />
            ))}
          </ul>
        </div>
      ) : (
        <div>
          &quot;{SearchQuery}&quot; was not found. It may be spelt incorrectly
          or there may be no stops on &quot;{SearchQuery}&quot;. You can find
          your nearest stop on&nbsp;
          <a href="/map" title="View the network map">
            this map
          </a>
        </div>
      )}
    </div>
  );
};

SearchResults.defaultProps = {
  SearchQuery: "",
  Title: "",
  Results: []
};

SearchResults.propTypes = {
  handlePlatformSelect: PropTypes.func.isRequired,
  SearchQuery: PropTypes.string,
  Title: PropTypes.string,
  Results: PropTypes.array
};

export default SearchResults;
